import { Card } from 'react-bootstrap';


const ShimmerBox = ({ width, height, className = '', style = {} }) => (
  <div
    className={`shimmer rounded ${className}`}
    style={{
      width,
      height,
      ...style
    }}
    aria-hidden
  />
);

export const TaskSearchItemSkeleton = () => {
  return (
    <Card
      className="w-100"
      style={{
        borderLeft: '5px solid #e9ecef',
        minWidth: 0,
        maxWidth: '100%',
        pointerEvents: 'none'
      }}
      aria-hidden
    >
      <Card.Body className="p-2">
        <div className="d-flex">
          <ShimmerBox width={18} height={18} className="rounded-circle mr-2 flex-shrink-0" />
          <div className="flex-grow-1" style={{ minWidth: 0 }}>
            <div className="d-flex justify-content-between align-items-start" style={{ gap: 4, minWidth: 0 }}>
              <ShimmerBox className="flex-grow-1" style={{ height: 16, maxWidth: '72%' }} />
              <ShimmerBox width={36} height={16} style={{ borderRadius: 12 }} className="mr-1" />
            </div>
            <ShimmerBox className="mt-3" style={{ height: 14, maxWidth: '60%' }} />
            <div
              className="d-flex align-items-center flex-wrap text-muted smallFont mt-2"
              style={{ rowGap: 4, columnGap: 16, minWidth: 0 }}
            >
              <ShimmerBox width={100} height={14} style={{ maxWidth: '30%' }}/>
              <ShimmerBox width={90} height={14} style={{ maxWidth: '30%' }}/>
            </div>

            <ShimmerBox width={60} height={14} className="mt-2" style={{ maxWidth: '30%' }}/>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export const TasksFlatGridLoadingSkeleton = () => {
  return (
    <div className="mt-3">
      <div className="row">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="col-12 col-md-6 mb-2 d-flex">
            <TaskSearchItemSkeleton />
          </div>
        ))}
      </div>
    </div>
  );
};

const KanbanColumnShellSkeleton = () => (
  <div
    className="w-100 rounded p-2 flex-shrink-0"
    style={{
      background: '#F7F7F7',
      minWidth: 0,
      maxWidth: '100%',
      overflow: 'hidden'
    }}
    aria-hidden
  >
    <div className="d-flex align-items-center justify-content-between mb-2 px-1">
      <ShimmerBox width={88} height={14} />
      <ShimmerBox width={26} height={20} className="rounded-pill" />
    </div>
    <div style={{ height: 'calc(100vh - 350px)' }} />
  </div>
);

export const TasksKanbanColumnsLoadingSkeleton = () => (
  <div
    className="mt-3"
    style={{ overflowX: 'auto', overflowY: 'hidden' }}
  >
    <div className="d-flex flex-nowrap" style={{ gap: 16, minWidth: 'min-content' }}>
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className="flex-shrink-0 d-flex" style={{ width: 300 }}>
          <KanbanColumnShellSkeleton />
        </div>
      ))}
    </div>
  </div>
);

export const TaskSearchItemsLoadingMoreSkeleton = ({ count = 2 }) => (
  <div className="d-flex flex-column" style={{ gap: 8 }}>
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="mb-2" style={{ minWidth: 0, maxWidth: '100%' }}>
        <TaskSearchItemSkeleton />
      </div>
    ))}
  </div>
);

export default TaskSearchItemSkeleton;
